/* Biolabs design-review fixes, 3 Nov 2026 (draft theme only).
   Rewards (Smile) launcher: icon-only on mobile. The launcher is a same-origin iframe, so the label is hidden inside it. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var CSS = 'button>span{display:none!important}button{justify-content:center!important;padding:0!important;width:100%!important;min-width:0!important;gap:0!important}button img{margin:0!important}';
  function apply() {
    var c = document.getElementById('smile-ui-lite-launcher-frame-container');
    if (!c) return;
    var f = c.querySelector('iframe'), doc = null;
    try { doc = f && f.contentDocument; } catch (e) { doc = null; }
    var on = mq.matches;
    c.classList.toggle('bl-smile-icon', on);
    if (!doc || !doc.head) return;
    var s = doc.getElementById('bl-smile-css');
    if (on && !s) { s = doc.createElement('style'); s.id = 'bl-smile-css'; s.textContent = CSS; doc.head.appendChild(s); }
    if (!on && s) s.remove();
    var b = doc.querySelector('button');
    if (b && !b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Rewards');
  }
  var n = 0, t = setInterval(function () { apply(); if (++n > 40) clearInterval(t); }, 750);
  if (mq.addEventListener) mq.addEventListener('change', apply);
  document.addEventListener('visibilitychange', apply);
  window.addEventListener('load', apply);
})();
